var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMyDebatesFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0147 2.43751L36.5607 11.9438C37.1464 12.5271 37.1464 13.4729 36.5607 14.0562L27.0147 23.5625C26.4289 24.1458 25.4792 24.1458 24.8934 23.5625C24.3076 22.9791 24.3076 22.0333 24.8934 21.45L31.8787 14.4938H6.5C5.67157 14.4938 5 13.825 5 13C5 12.175 5.67157 11.5062 6.5 11.5062H31.8787L24.8934 4.55001C24.3076 3.96666 24.3076 3.02086 24.8934 2.43751C25.4792 1.85416 26.4289 1.85416 27.0147 2.43751Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9853 39.5625L5.43934 30.0562C4.85355 29.4729 4.85355 28.5271 5.43934 27.9438L14.9853 18.4375C15.5711 17.8542 16.5208 17.8542 17.1066 18.4375C17.6924 19.0209 17.6924 19.9667 17.1066 20.55L10.1213 27.5062L35.5 27.5062C36.3284 27.5062 37 28.175 37 29C37 29.825 36.3284 30.4938 35.5 30.4938L10.1213 30.4938L17.1066 37.45C17.6924 38.0333 17.6924 38.9791 17.1066 39.5625C16.5208 40.1458 15.5711 40.1458 14.9853 39.5625Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMyDebatesFilled);
export default __webpack_public_path__ + "static/media/icon-myDebates-filled.8e5e3d7223556ef62b132a97fcb921af.svg";
export { ForwardRef as ReactComponent };